// Data source is laws.json (edit that file). These exports keep the app's imports unchanged.
import data from './laws.json';
export const internationalData = data.internationalData;
export const allInternationalLaws = Object.values(internationalData).flat();
export const regions = data.regions;
